<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="content-main">
        <v-tabs v-model="tab" style="background-color: white">
          <v-tab v-for="item in visibleItems" :key="item.key">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-window v-model="tab">
          <v-tabs-window-item key="0">
            <Ingresos></Ingresos>
          </v-tabs-window-item>
          <v-tabs-window-item key="1">
            <Egresos></Egresos>
          </v-tabs-window-item>
          <v-tabs-window-item key="2">
            <IngresosDetalle></IngresosDetalle>
          </v-tabs-window-item>
          <v-tabs-window-item key="3">
            <EgresosDetalle></EgresosDetalle>
          </v-tabs-window-item>
          <v-tabs-window-item key="4">
            <Ocupacion></Ocupacion>
          </v-tabs-window-item>
          <v-tabs-window-item key="5">
            <StockProducto></StockProducto>
          </v-tabs-window-item>
          <v-tabs-window-item key="6">
            <MovimientoDeStock></MovimientoDeStock>
          </v-tabs-window-item>
          <v-tabs-window-item key="7">
            <Productividad></Productividad>
          </v-tabs-window-item>
          <v-tabs-window-item key="8" v-if="!isClientUser">
            <ProductividadOperario></ProductividadOperario>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </v-container>
  </div>
</template>

<script>
import Ingresos from "./Ingresos.vue";
import Egresos from "./Egresos.vue";
import Ocupacion from "./Ocupacion.vue";
import StockProducto from "./StockProducto.vue";
import IngresosDetalle from "./IngresosDetalle.vue";
import EgresosDetalle from "./EgresosDetalle.vue";
import MovimientoDeStock from "./MovimientoDeStock.vue";
import Productividad from "./Productividad.vue";
import ProductividadOperario from "./ProductividadOperario.vue";
import Title from "@/components/Title.vue";
import UserTypeConstant from "@/constants/user_type";

export default {
  mixins: [],
  components: { Title, Ingresos, Egresos, IngresosDetalle, EgresosDetalle, Ocupacion, StockProducto, MovimientoDeStock, Productividad, ProductividadOperario },
  data() {
    return {
      // El reporte por operario expone productividad interna: no va para clientes
      isClientUser: localStorage.getItem("user_type") == UserTypeConstant.CLIENT,
      page_title: "Reportes",
      tab: 0,
      list: [],
      items: [
        { tab: "Ingresos", key: 0 },
        { tab: "Egresos", key: 1 },
        { tab: "Detalle de Ingresos", key: 2 },
        { tab: "Detalle de Egresos", key: 3 },
        { tab: "Ocupacion", key: 4 },
        { tab: "Stock Producto", key: 5 },
        { tab: "Movimiento de Stock", key: 6 },
        { tab: "Productividad por Envío", key: 7 },
        { tab: "Productividad por Operario", key: 8 },
      ],
    };
  },
  computed: {
    visibleItems() {
      return this.isClientUser ? this.items.filter((item) => item.key != 8) : this.items;
    },
  },
  methods: {},
};
</script>
